import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

export default class ScrollAnime {
    constructor() {
        this._init();
    }

    _init() {
        gsap.registerPlugin(ScrollTrigger);

        this.celebrationlists = [...document.querySelectorAll('.js-celebrationlist')];

        this._update();
        window.addEventListener('scroll', this._update.bind(this));
    }

    _update() {
        this.celebrationlists.forEach(($illulist) => {
            ScrollTrigger.create({
                trigger: $illulist,
                start: 'top 70%',
                onEnter: (self) => {
                    if ($illulist.classList.contains('-view')) return;

                    this._showThumb($illulist);

                    $illulist.classList.add('-view');
                },
            });
        });

    }

    /**
     * サムネイル
     */
    _showThumb($illulist) {
        const $thumbs = [...$illulist.querySelectorAll('.archive__ph')];
        const vects = ['lr', 'rl', 'tb', 'bt'];

        $thumbs.forEach(($t) => {
            const d = Math.random() * 0.5 * 1000 + 500;

            setTimeout(() => {
                const v = vects[Math.floor(Math.random() * vects.length)];
                const $color = $t.querySelector('.-color');
                $color.setAttribute('data-vect', v);
                gsap.set($color, { visibility: 'visible' });

                $t.classList.add('-view');
            }, d);
        });
    }
}
